import Pricing from './Pricing';

export default Pricing;
